import { createStyledBreakpointsTheme } from 'styled-breakpoints'

import breakpoints from './breakpoints'
import colors from './colors'
import fonts from './fonts'
import gradients from './gradients'
import shadows from './shadows'

const styledBreakpoints = createStyledBreakpointsTheme({
  // @ts-ignore
  breakpoints,
})?.breakpoints

const DEFAULT_THEME = {
  name: 'default',

  defaultTransitionTime: '0.3s',
  //0  1  2  3  4   5   6   7   8   9   10  11  12  13  14  15  16  17  18  19
  space: [
    0, 2, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 72, 80,
    //20  21
    88, 96,
  ],
  //          0   1   2   3   4   5   6   7   8   9
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72, 96],
  //             0    1    2
  fontWeights: [400, 500, 700],
  //               0   1   2   3   4
  controlHeights: [24, 32, 40, 48, 56],

  colors,
  gradients,
  shadows,
  fonts,
  breakpoints: Object.values(breakpoints),
  styledBreakpoints,
}

export default DEFAULT_THEME
